import PropTypes from "prop-types";
import React from "react";

export default class DataLayer extends React.Component {
  static get data() {
    const { dataLayer } = window.lp.analytics;
    dataLayer[1] = dataLayer[1] || {};
    return dataLayer[1];
  }

  static propTypes = {
    data: PropTypes.objectOf(Object),
  };

  componentDidMount() {
    Object.assign(DataLayer.data, this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    Object.assign(DataLayer.data, nextProps.data);
  }

  render() {
    return (
      <div className="DataLayer" />
    );
  }
}



// WEBPACK FOOTER //
// ./assets/shared/components/dataLayer.jsx